class PageHeader extends React.Component {

    render() {
        var self = this;

        return (
            <div className='row'>
                <div className='col-12'>
                    <div className={[
                        'page-header',
                        (this.props.noMargin ? 'page-header__no-margin' : '')
                    ].join(' ')}>

                        {this.props.title}
                    </div>
                </div>
            </div>
        );
    }
}

export default PageHeader;



// WEBPACK FOOTER //
// ./ui_src/app/components/form/layout/PageHeader.react.jsx